export default "__VITE_ASSET__Bwkl2c$7__"